/*!
 * ORDER/Voucher
 *
 * @author Andrew Hill
 *
 * @param voucherCode
 * @param order
 */
var Strategies = require('./Voucher.Strategies');

module.exports = function(voucherCode, order){
    this.voucherCode = voucherCode;
    this.errors = [];
    this.discountAmount = 0;

    /**
     * Public API
     */
    this.doDiscountAmount = function(){
        if(this._isValid()){
            this.discountAmount = this._calculateDiscount();
        }
    };

    this._isValid = function(){
        return this._exists() && this._isNotExpired();
    };

    this._isNotExpired = function(){
        var nowDate = new Date();
        var validDate = new Date(this.voucher.exp);

        if(validDate < nowDate){
            this.errors.push({
                message: "Voucher code is expired"
            });

            return false;
        }

        return true;
    };

    this._exists = function(){
        if(typeof ORDER.Vouchers.discount_codes[this.voucherCode] === 'undefined'){
            this.errors.push({
                message: "Voucher code does not exist"
            });

            return false;
        }

        this.voucher = ORDER.Vouchers.discount_codes[this.voucherCode];
        this.strategy = new Strategies[this.voucher.type];

        return true;
    };

    this._calculateDiscount = function(){
        //Strategies
        return this.strategy.calculate(order, this);
    };

    this.hasMinSpendValue = function(orderAmount, voucher){
        var minOrderAmount = voucher.voucher.min_order;

        if (orderAmount < minOrderAmount) {
            var spendMore = minOrderAmount - orderAmount;
            voucher.errors.push({ message: "Sorry. You are below the minimum spend for your voucher. Add another £" + spendMore.toFixed(2) + " to your order"});
            return false;
        }

        return true;
    };

    this.hasMinItemsValue = function(orderItems, voucher, itemName){
        var minItemsAmount = voucher.voucher.min_order;

        if (orderItems < minItemsAmount) {
            var itemsMore = minItemsAmount - orderItems;
            voucher.errors.push({ message: "Sorry. You are below the minimum " + itemName + " for your voucher. Add another " + itemsMore + " " + itemName + " to your order"});
            return false;
        }

        return true;
    };
};